import React from 'react';

import { FileUploadText, FileUploadTextPrimary } from '../styled';

function DragTextDragOver() {
	return (
		<FileUploadText>
			<FileUploadTextPrimary>Click to upload</FileUploadTextPrimary> or drag and drop
		</FileUploadText>
	);
}

export default DragTextDragOver;
